import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useSetAtom } from "jotai";
import { Platform } from "react-native";

import { setPreAuthenticatedPathAtom } from "@/features/Authentication/atoms/actions/setPreAuthenticatedPath/setPreAuthenticatedPath";
import { BaseNavigatorParamList } from "@/navigators/BaseNavigator/types";

export const useEventDetailLoginRedirect = (
  clubSlug: string,
  eventId: string
) => {
  const parentNavigation =
    useNavigation<NavigationProp<BaseNavigatorParamList>>();

  const setPreAuthenticatedPath = useSetAtom(setPreAuthenticatedPathAtom);

  const handleRedirect = (shouldInitiateSignUp: boolean = false) => {
    if (Platform.OS === "web") {
      const path = `/patron/club/${clubSlug}/event-detail/${eventId}`;

      const pathWithParams = shouldInitiateSignUp
        ? `${path}?joinEvent=true`
        : path;

      if (pathWithParams !== "/patron") {
        setPreAuthenticatedPath({ path: pathWithParams, force: true });
      }
    }

    parentNavigation.navigate("Club", {
      clubSlug,
      screen: "Login",
      params: {
        clubSlug,
      },
    });
  };

  return handleRedirect;
};
